/**
 * PC Remote Library
 * Author: Divya Tiwari
 * Created On: 13-03-2023
 */

import React from 'react';
import '../../shared/LibraryTheme.scss';
import BarChart from '../BarChart/BarChart';
import { ConversionType } from '../UnitHandling/Constants';
import {  getConvertedValue, getConvertedValues } from '../UnitHandling/UnitHandling';
import { handleNegativeScenario } from '../../shared/shared-utility';

type nullableType = number | null | undefined;
interface IReduceEnergyUsageProps {
  energyBaselineWithoutIBO: number | null;
  energyConsumptionWithIBO: number | null;
  energySavings: number | null;
  screenOption: string;
  pastESDisplayPercentage: nullableType;
  energySavingsIncrased: boolean;
  totalDays: string;
}

/**
 *
 * Component to display Carbon Usage Graph
 *
 */

function ReduceEnergyUsage(props: IReduceEnergyUsageProps) {
  let screenOption = props.screenOption.toLowerCase();
  let energyContainer, triangle: string,barClassName='';
  let negativeEnergy = 0;
  let barpercentage = '100';
  const number100 = 100;
const measurementUnit = 'kilowatt hour';

  // bar percentage condition
  if (props.energyBaselineWithoutIBO && props.energyConsumptionWithIBO) {
    if (props.energyConsumptionWithIBO < props.energyBaselineWithoutIBO) {
      barpercentage = (
        number100 -
        ((props.energyBaselineWithoutIBO - props.energyConsumptionWithIBO) /
          props.energyBaselineWithoutIBO) *
          number100
      ).toString();
    } else if (
      props.energyConsumptionWithIBO === props.energyBaselineWithoutIBO
    ) {
      barpercentage = barpercentage.toString();
    } else {
      barpercentage = barpercentage.toString();
    }
  } else {
    barpercentage = barpercentage.toString();
  }

  // red- green triangle condition
  const checkEnergySaving = () => {
    if (props.energySavingsIncrased === true) {
      triangle = 'arrow-down';
    } else {
      triangle = 'arrow-up';
    }
  };
  const checkScreenOption = () => {
    if (screenOption === 'landscape') {
      energyContainer =
        'reduce-energy-usage-container lanscape-energy-container';
        barClassName='barchart-landscape';
    } else {
      energyContainer =
        'reduce-energy-usage-container portrait-energy-container';
        barClassName='barchart-portrait';
    }
  };

  checkEnergySaving();
  checkScreenOption();
  const checkPortrait = () => {
    if(props.screenOption !== 'portrait') {
      return 'reduce-energy-usage-heading-container align-right';
    } else {
      return 'reduce-energy-usage-heading-container';
    };
  };

  const getBarPercentage = () => {
    if(!props.pastESDisplayPercentage) {
      return '100';
    } else {
      return barpercentage;
    };
  };

  const getBarPosition = () =>{
    if(screenOption == 'landscape') {
      return 'end';
    } else {
      return 'start';
    };
  };

  const getBarChartClass = () => {
    if(screenOption == 'landscape') {
      return 'bar-chart-summary-landscape';
    }else {
      return 'bar-chart-summary';
    };
  };
  const getEnergyConsumptionWithIBO = () => {
    if(props.energyConsumptionWithIBO) {
      return props.energyConsumptionWithIBO;
    } else {
      return negativeEnergy;
    };
  };
  const getEnergyBaselineWithoutIBO = () => {
    if(props.energyBaselineWithoutIBO) {
      return props.energyBaselineWithoutIBO;
    } else {
      return negativeEnergy;
    };
  };

  const getEsPercentageUI = () => {
    if(props.pastESDisplayPercentage) {
      return (
        <div className="flex flex-row align-center">
          <span className={`${triangle}`} />
          <span className="increased-value">
            {props.pastESDisplayPercentage}% {'  '} from last week
          </span>
        </div>
      );
    } else {
      return (
        <div className="increased-value-equal-gap"></div>
      );
    };
  };
  // Unit Conversion
  const energyConsumptionWithIBO= getConvertedValue(ConversionType.ELECTRICITY,measurementUnit,getEnergyConsumptionWithIBO()).Value;
  const energyConsumptionWithIBOUnit= getConvertedValue(ConversionType.ELECTRICITY,measurementUnit,getEnergyConsumptionWithIBO()).Unit;

  const energyBaselineWithoutIBO = getConvertedValue(ConversionType.ELECTRICITY,measurementUnit,getEnergyBaselineWithoutIBO()).Value;
  const energyBaselineWithoutIBOUnit = getConvertedValue(ConversionType.ELECTRICITY,measurementUnit,getEnergyBaselineWithoutIBO()).Unit;

  const energySavings = getConvertedValue(ConversionType.ELECTRICITY,measurementUnit,handleNegativeScenario(props.energySavings)).Value;
  const energySavingsUnit = getConvertedValue(ConversionType.ELECTRICITY,measurementUnit,handleNegativeScenario(props.energySavings)).Unit;

  return (
    <div className={energyContainer}>
      <div
        className={checkPortrait()}
      >
        <div className="reduce-energy-heading">Reduced Energy Usage</div>
        <div className="energy-data-text">
        {getConvertedValues(energySavings)} {' '}
        {energySavingsUnit}*
        </div>
        {getEsPercentageUI()}
      </div>
      <div className="energy-status-bar-chart">
        <BarChart
          withIBObgcolor={'#A891FF'}
          progress={getBarPercentage()}
          withOutIBObgcolor={'#E2C7FF'}
          barPosition={getBarPosition()}
          barClassName={barClassName}
        />
        <div
          className={getBarChartClass()}
        >
          <div className="with-ibo-container">
            {<div className="with-ibo-heading"><div> With</div>  <div>Optimization</div></div>}
            <div className="with-ibo-value">
              <div className="energy-ibo-circle" />
              <div>
              <span className="emaas-summary-value actual-cost">
                      {getConvertedValues(energyConsumptionWithIBO)}  {' '}
                    </span>
                    <span className="emaas-summary-unit">
                      {energyConsumptionWithIBOUnit}
                    </span>
              </div>
            </div>
          </div>
          <div className="without-ibo-container">
            <div className="without-ibo-heading">
            <div> Without</div>  <div>Optimization</div>
               </div>
            <div className="without-ibo-value">
              <div>
              <span className="emaas-summary-value actual-cost">
                      {getConvertedValues(energyBaselineWithoutIBO)}  {' '}
                    </span>
                    <span className="emaas-summary-unit">
                      {energyBaselineWithoutIBOUnit}
                    </span>
              </div>
              <div className="energy-without-ibo-circle" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReduceEnergyUsage;
